import React from 'react';
import { useHistory } from 'react-router-dom';

import UserList from 'containers/UserList';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { GroupedListModel } from 'models/groupedList';

const UsersListContainer = () => {
  const { t } = useStoreTranslation();
  const history = useHistory();

  const handleSelect = (users: GroupedListModel[]) => {
    history.push(`/corporate/usersForm/${users.first().id}`);
  };

  const handleGoBack = () => {
    history.push('/corporate/dashboard');
  };

  return (
    <UserList
      title={t('users.title')}
      selectableType="arrow"
      onConfirmSelection={handleSelect}
      onCloseSelectionScreen={handleGoBack}
      allUsers={true}
    />
  );
};

export default UsersListContainer;
